import hooks from 'src/events/Hook';
import { getElement } from 'utils/dom';

export default function blcktive$insert(target, anchor) {
  if (!this.fragment.rendered) {
    // TODO create, and link to, documentation explaining this
    throw new Error(
      'The API has changed - you must call `blcktive.render(target[, anchor])` to render your blcktive instance. Once rendered you can use `blcktive.insert()`.'
    );
  }

  target = getElement(target);
  anchor = getElement(anchor) || null;

  if (!target) {
    throw new Error('You must specify a valid target to insert into');
  }

  target.insertBefore(this.detach(), anchor);
  this.el = target;

  (target.__blcktive_instances__ || (target.__blcktive_instances__ = [])).push(this);
  this.isDetached = false;

  fireInsertHook(this);
}

function fireInsertHook(blcktive) {
  hooks.insert.fire(blcktive);

  blcktive.findAllComponents('*').forEach(child => {
    fireInsertHook(child.instance);
  });
}
